import { Link } from "react-router-dom";
import { formatINR, formatKM } from "../lib/api";
import { Fuel, Calendar, Gauge } from "lucide-react";

const FALLBACK = "https://images.unsplash.com/photo-1503376780353-7e6692767b70?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjYXIlMjBzbGVlayUyMG1vZGVybnxlbnwwfHx8fDE3Nzk0NTUzNTB8MA&ixlib=rb-4.1.0&q=85";

export default function CarCard({ car, idx = 0 }) {
  const img = (car.images && car.images[0]) || FALLBACK;
  return (
    <Link
      to={`/car/${car.id}`}
      data-testid={`car-card-${car.id}`}
      className="car-card group block overflow-hidden ry-fade-up"
      style={{ animationDelay: `${Math.min(idx * 70, 600)}ms` }}
    >
      <div className="aspect-[4/3] overflow-hidden bg-gray-100 relative">
        <img
          src={img}
          alt={`${car.brand} ${car.model}`}
          className="car-image w-full h-full object-cover"
          loading="lazy"
        />
        {car.featured && (
          <span className="absolute top-4 left-4 bg-black text-white text-[10px] tracking-[0.2em] uppercase px-3 py-1.5">
            Featured
          </span>
        )}
        {car.sold && (
          <span className="absolute top-4 right-4 bg-[#E63946] text-white text-[10px] tracking-[0.2em] uppercase px-3 py-1.5">
            Sold
          </span>
        )}
      </div>
      <div className="p-6">
        <p className="overline text-[#9D8C70]">{car.brand}</p>
        <h3 className="font-display text-xl font-medium mt-1.5 tracking-tight text-black">
          {car.model}
        </h3>
        <div className="flex items-center gap-4 mt-4 text-xs text-gray-500">
          <span className="inline-flex items-center gap-1.5">
            <Calendar size={13} strokeWidth={1.5} /> {car.year}
          </span>
          <span className="inline-flex items-center gap-1.5">
            <Gauge size={13} strokeWidth={1.5} /> {formatKM(car.mileage)}
          </span>
          <span className="inline-flex items-center gap-1.5">
            <Fuel size={13} strokeWidth={1.5} /> {car.fuel}
          </span>
        </div>
        <div className="mt-5 pt-5 border-t border-gray-100 flex items-baseline justify-between">
          <span className="font-display text-2xl tracking-tight text-black">
            {formatINR(car.price)}
          </span>
          <span className="text-xs text-gray-500">{car.location}</span>
        </div>
      </div>
    </Link>
  );
}
